import React, { useState, useEffect } from "react";
import {
  Radio,
  Row,
  Col,
  Space,
  Divider,
  Typography,
  Button,
  Empty,
  Spin,
} from "antd";
import { JobCard } from "./JobCard";
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";
import { MehOutlined } from "@ant-design/icons";
import useCommonsService from "../../../services/useCommonsService";
import usePersonnelAdvertService from "../../../services/usePersonnelAdvertService";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";
const { Title } = Typography;

const JobListingDeneme = () => {
  const isSmallScreen = useIsSmallScreen();
  const navigate = useNavigate();
  const [selectedLabelKey, setSelectedLabelKey] = useState(null);

  const { useGetLabelKeys } = useCommonsService();
  const { useGetAdvertsByLabelKey } = usePersonnelAdvertService();

  const { data: labelKeys, isLoading: isLabelKeysLoading } = useGetLabelKeys();
  const labelKeysToShow = labelKeys?.slice(0, 4);

  // Create individual queries for each possible label key
  const firstLabelQuery = useGetAdvertsByLabelKey(labelKeysToShow?.[0]?.value);
  const secondLabelQuery = useGetAdvertsByLabelKey(labelKeysToShow?.[1]?.value);
  const thirdLabelQuery = useGetAdvertsByLabelKey(labelKeysToShow?.[2]?.value);
  const fourthLabelQuery = useGetAdvertsByLabelKey(labelKeysToShow?.[3]?.value);

  // Combine queries into an array for easier access
  const advertQueries = [
    { labelKey: labelKeysToShow?.[0]?.value, ...firstLabelQuery },
    { labelKey: labelKeysToShow?.[1]?.value, ...secondLabelQuery },
    { labelKey: labelKeysToShow?.[2]?.value, ...thirdLabelQuery },
    { labelKey: labelKeysToShow?.[3]?.value, ...fourthLabelQuery },
  ].filter((query) => query.labelKey); // Filter out undefined label keys

  useEffect(() => {
    if (labelKeysToShow?.length > 0 && !selectedLabelKey) {
      setSelectedLabelKey(labelKeysToShow[0].value);
    }
  }, [labelKeysToShow]);

  if (isLabelKeysLoading || !labelKeysToShow) {
    return <Spin spinning={true} />;
  }

  const handleLabelChange = (e) => {
    setSelectedLabelKey(e.target.value);
  };

  const handleGoListingsWithLabelKey = (labelKey) => {
    navigate(PageRoutes.listings, { state: { labelKey: labelKey } });
  };

  const renderAdverts = (labelKey) => {
    const queryData = advertQueries.find((q) => q.labelKey === labelKey);

    if (!queryData) return null;

    if (queryData.isLoading) {
      return (
        <Col span={24}>
          <Spin spinning={true} />
        </Col>
      );
    }

    const adverts = queryData.data?.data?.pagination?.data || [];

    if (adverts.length > 0) {
      return adverts.map((advert) => (
        <Col span={isSmallScreen ? 24 : 12} key={advert.id}>
          <JobCard job={advert} />
        </Col>
      ));
    }

    return (
      <Col span={24}>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Empty
            image={<MehOutlined style={{ fontSize: 48, color: "#999" }} />}
            description="Henüz Bu Kategoride İlan Bulunmuyor"
          />
        </div>
      </Col>
    );
  };

  // Rest of your component remains the same...
  return (
    <Row gutter={[16, 16]} style={{ margin: 30 }}>
      {!isSmallScreen && (
        <Col span={6} style={{ textAlign: "right" }}>
          <div>
            <Radio.Group
              style={{
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                borderRadius: "0",
                padding: "16px",
                backgroundColor: "white",
              }}
              onChange={handleLabelChange}
              value={selectedLabelKey}
              optionType="button">
              <Space direction="vertical">
                {labelKeysToShow.map((labelKey) => (
                  <React.Fragment key={labelKey.value}>
                    <Radio
                      style={{
                        width: 200,
                        textAlign: "left",
                        border: "none",
                      }}
                      value={labelKey.value}>
                      {labelKey.label + " İşler"}
                    </Radio>
                    <Divider orientation="right" style={{ margin: "8px 0" }} />
                  </React.Fragment>
                ))}
              </Space>
            </Radio.Group>
          </div>
        </Col>
      )}

      <Col span={isSmallScreen ? 24 : 18}>
        {!isSmallScreen ? (
          <div
            style={{
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              marginBottom: 16,
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}>
              <Title level={3} style={{ marginBottom: 0 }}>
                {
                  labelKeysToShow.find(
                    (labelKey) => labelKey.value === selectedLabelKey
                  )?.label
                }
              </Title>
              <Button
                onClick={() => {
                  handleGoListingsWithLabelKey(
                    labelKeysToShow.find(
                      (labelKey) => labelKey.value === selectedLabelKey
                    )?.value
                  );
                }}
                type="link"
                style={{ marginRight: "0" }}>
                Tüm İlanlar
              </Button>
            </div>

            <Row gutter={[16, 16]}>{renderAdverts(selectedLabelKey)}</Row>
          </div>
        ) : (
          // Mobile view
          <>
            {labelKeysToShow.map((label) => (
              <div
                key={label.value}
                style={{
                  width: "100%",
                  marginBottom: "40px",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}>
                  <Title level={3} style={{ marginBottom: "0" }}>
                    {label.label + " İşler"}
                  </Title>
                  <Button type="link" style={{ marginRight: "0" }}>
                    Tüm İlanlar
                  </Button>
                </div>
                <Row gutter={[16, 16]}>{renderAdverts(label.value)}</Row>
              </div>
            ))}
          </>
        )}
      </Col>
    </Row>
  );
};

export default JobListingDeneme;
